import HttpInterceptor from './HttpInterceptor'

export default {

  name: 'UserService',

  getUserInfo() {
    return HttpInterceptor.httpClient().get('users/info')
  },

  getAllUsers() {
    return HttpInterceptor.httpClient().get('users/all')
  },

  getProfiles() {
    return HttpInterceptor.httpClient().get('users/profiles')
  },

  get2faRecoveryCodes() {
    return HttpInterceptor.httpClient().get('users/activate2fa/recoverycodes')
  },

  get2faQRCode() {
    return HttpInterceptor.httpClient().get('users/activate2fa/qrcode', {responseType: 'blob'})
  },

  createUser(newUser) {
    return HttpInterceptor.httpClient().post('sage/users/create', newUser)
  },

  addUser(newUser) {
    return HttpInterceptor.httpClient().post('users/add', newUser)
  },

  deactivate2fa(code) {
    return HttpInterceptor.httpClient().post('users/deactivate2fa', code)
  },

  prepare2fa() {
    return HttpInterceptor.httpClient().post('users/activate2fa/prepare')
  },

  finish2fa(code) {
    return HttpInterceptor.httpClient().post('users/activate2fa/finish', code)
  },

  forgotPassword(user) {
    return HttpInterceptor.httpRecaptchaClient().put('users/forgotpassword', user)
  },

  deleteUser(userId) {
    return HttpInterceptor.httpClient().delete('users/delete/' + userId)
  },

  unlockUser(user) {
    return HttpInterceptor.httpClient().put('users/unlock', user)
  },

  updateUser(user) {
    return HttpInterceptor.httpClient().put('users/update/' + user.id, user)
  },

  takeOverIdentity(customerNo) {
    return HttpInterceptor.httpClient().put('sage/users/identity/takeover', customerNo)
  },

  resetIdentity() {
    return HttpInterceptor.httpClient().put('sage/users/identity/takeover/reset')
  },
}
